// extracted by mini-css-extract-plugin
export default {"container":"sitemap-module__container__doaV0","list":"sitemap-module__list__8M++V"};